//
//
//
//
//
//
//
//
//

export default {
  props: [],
  created () {},
  mounted () {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  filters: {},
  methods: {
    onLink () {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
